import React, { useContext } from 'react';

import { ThemingContext } from '../../../hoc/Theming/Theming';

import './PlainButton.scss';

const PlainButton = (props) => {
  const styling = useContext(ThemingContext)

  const { blue, onClick, icon, children, className, size } = props;

  return (
    <button
      className={`plain-button 
      plain-${blue ? 'blue' : 'normal'} 
      ${size && `plain-${size}`} 
      ${className}`}
      onClick={onClick}
      style={styling.text.button}
    >
      <i className={icon}></i>
      {children}
    </button>
  );
};

export default PlainButton;
